import type { Theme } from '@mui/material/styles';
import { alpha } from '@mui/material/styles';
import { borderRadius } from '../../../theme/theme';
import {
  getWorkspaceActionButtonSx,
  getWorkspaceIconButtonSx,
  type WorkspaceActionTone,
} from '../../../shared/ui/workflow/WorkflowWorkspacePrimitives';

export const EXPORT_RAIL_CONTROL_SIZE = 28;

export function getExportRailActionButtonSx(
  theme: Theme,
  tone: WorkspaceActionTone = 'secondary'
): Record<string, any> {
  return {
    ...getWorkspaceActionButtonSx(theme, {
      tone,
      minHeight: EXPORT_RAIL_CONTROL_SIZE,
    }),
    height: EXPORT_RAIL_CONTROL_SIZE,
    minHeight: EXPORT_RAIL_CONTROL_SIZE,
    py: 0,
    borderRadius: `${borderRadius.sm}px`,
    flexShrink: 0,
  };
}

export function getExportRailQuietIconButtonSx(theme: Theme): Record<string, any> {
  return {
    ...getWorkspaceIconButtonSx(theme, { size: EXPORT_RAIL_CONTROL_SIZE }),
    minWidth: EXPORT_RAIL_CONTROL_SIZE,
    minHeight: EXPORT_RAIL_CONTROL_SIZE,
    flex: `0 0 ${EXPORT_RAIL_CONTROL_SIZE}px`,
    border: 'none',
    backgroundColor: 'transparent',
    color: theme.palette.text.secondary,
    '&:hover': {
      backgroundColor: alpha(theme.palette.primary.main, 0.08),
    },
    '&.Mui-disabled': {
      backgroundColor: 'transparent',
    },
  };
}
